/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Language } from './Language';
import {
	LanguageFromJSON,
	LanguageFromJSONTyped,
	LanguageToJSON,
	LanguageToJSONTyped,
} from './Language';
import type { EasyClaimDocumentType } from './EasyClaimDocumentType';
import {
	EasyClaimDocumentTypeFromJSON,
	EasyClaimDocumentTypeFromJSONTyped,
	EasyClaimDocumentTypeToJSON,
	EasyClaimDocumentTypeToJSONTyped,
} from './EasyClaimDocumentType';

/**
 *
 * @export
 * @interface PutDocumentRequest
 */
export interface PutDocumentRequest {
	/**
	 *
	 * @type {string}
	 * @memberof PutDocumentRequest
	 */
	caseId?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PutDocumentRequest
	 */
	fileName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PutDocumentRequest
	 */
	fileContent?: string | null;
	/**
	 *
	 * @type {EasyClaimDocumentType}
	 * @memberof PutDocumentRequest
	 */
	documentType?: EasyClaimDocumentType;
	/**
	 *
	 * @type {Language}
	 * @memberof PutDocumentRequest
	 */
	resultLanguage?: Language;
	/**
	 *
	 * @type {string}
	 * @memberof PutDocumentRequest
	 */
	documentId?: string | null;
}

/**
 * Check if a given object implements the PutDocumentRequest interface.
 */
export function instanceOfPutDocumentRequest(value: object): value is PutDocumentRequest {
	return true;
}

export function PutDocumentRequestFromJSON(json: any): PutDocumentRequest {
	return PutDocumentRequestFromJSONTyped(json, false);
}

export function PutDocumentRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PutDocumentRequest {
	if (json == null) {
		return json;
	}
	return {
		caseId: json['caseId'] == null ? undefined : json['caseId'],
		fileName: json['fileName'] == null ? undefined : json['fileName'],
		fileContent: json['fileContent'] == null ? undefined : json['fileContent'],
		documentType:
			json['documentType'] == null
				? undefined
				: EasyClaimDocumentTypeFromJSON(json['documentType']),
		resultLanguage:
			json['resultLanguage'] == null ? undefined : LanguageFromJSON(json['resultLanguage']),
		documentId: json['documentId'] == null ? undefined : json['documentId'],
	};
}

export function PutDocumentRequestToJSON(json: any): PutDocumentRequest {
	return PutDocumentRequestToJSONTyped(json, false);
}

export function PutDocumentRequestToJSONTyped(
	value?: PutDocumentRequest | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		caseId: value['caseId'],
		fileName: value['fileName'],
		fileContent: value['fileContent'],
		documentType: EasyClaimDocumentTypeToJSON(value['documentType']),
		resultLanguage: LanguageToJSON(value['resultLanguage']),
		documentId: value['documentId'],
	};
}
